import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Antd from 'ant-design-vue'
import 'ant-design-vue/dist/antd.css'
import './styles/common.scss'
import api from '@/api/index' // 老的，不动
import http from '@/server' // 新的
import VueCoreVideoPlayer from 'vue-core-video-player'
import { isIP } from './utils/tool'
import * as tools from './utils/tool'
import VueBus from 'vue-bus'
import VueClipboard from 'vue-clipboard2'
import echarts from '@/plugins/echarts'
import customVideo from '@/plugins/customVideo'
import loading from './plugins/myLoading/loading'
import '@/assets/fonts/font.css'

Vue.use(customVideo)
Vue.use(VueCoreVideoPlayer)
Vue.use(VueClipboard)
Vue.prototype.$api = api
Vue.prototype.$http = http
Vue.prototype.$tools = tools
Vue.use(Antd)
Vue.use(VueBus)
Vue.use(loading)
Vue.prototype.$echarts = echarts
Vue.config.productionTip = false

let { hostname, protocol, href } = window.location
let targetProtocol = 'https:'
// 非本地server
if (hostname !== 'localhost' && !isIP(hostname)) {
  if (protocol !== targetProtocol) {
    window.location.href = targetProtocol + href.substring(protocol.length)
  }
}

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
